import Record from "slotworks/model/gameplay/records/record";

/**
 * Pick Bonus - Use when player picks whilst looking for (n) matches
 */
export default class PickMatchRecord extends Record {
    public index: number;
    public value: string | number;
    public isPrize: boolean;
    public complete: boolean;
}
